module.exports = __webpack_public_path__ + "static/media/bg-frame-blue.b09c24fd.png";